module.exports = __webpack_public_path__ + "img/toilet.47a863b8.svg";